(function ($) {
	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the process-steps-block HTML.
	 *
	 * @date    04/05/2024
	 * @since   4.0.0
	 *
	 * @return  void
	 */
	const initializeBlock = function ($block) {};

	// Initialize each block on a page load (front end).
	$(document).ready(function () {
		$('.wp-block-acf-process-steps-block').each(function () {
			initializeBlock($(this));
		});
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction(
			'render_block_preview/type=process-steps-block',
			function ($block) {
				initializeBlock($($block));
			}
		);
	}
})(jQuery);
